import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { noPreRenderedStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import {
  getExpressCheckoutPageProps,
  ExpressCheckoutPageProps,
  ExpressCheckoutPage,
} from '@/views/ExpressCheckoutView/pageProps.server'

export const getStaticPaths = noPreRenderedStaticPaths

// Note: revalidate: is returned from getExpressCheckoutPageProps
export const getStaticProps = getStaticPropsErrorHandler<ExpressCheckoutPageProps>(
  { filePath: 'pages/[locale]/express-checkout/[projectSlug]/index.tsx' },
  async ({ federationClient, locale, next404, params }) => {
    const translations = await loadTranslations(locale, ['common', 'pif', 'account', 'app-promo'])
    return getExpressCheckoutPageProps({ params, locale, federationClient, next404, translations })
  },
)

export default ExpressCheckoutPage
